export const shouldUnitBeGreyedOut = (progress) => {
  const isActive =
    progress?.isCurrent ||
    progress?.isCompleted ||
    progress?.percentOfExercisesSeen > 0
  return !isActive
}
